import React from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import { useSelector } from "react-redux";
import { Link, ResponsiveImage } from "@quintype/components";
import { formatToFullDate } from "../../utils/date-formatter";
import useIsMobile from "../../../hooks/useIsMobile";
import "./leadership-story-card.m.css";

export const LeadershipStoryCard = ({ story }) => {
    const isMobile = useIsMobile();
    if (!story) return null;

    const {
        url: storyUrl,
        "hero-image-s3-key": heroImageKey,
        "hero-image-metadata": heroImageMetadata,
        "first-published-at": firstPublishedAt,
        metadata = {},
        subheadline,
        headline,
    } = story;

    const formattedDate = formatToFullDate(firstPublishedAt);

    const expertName = get(metadata, "expert") || "";
    const expertDescription = get(metadata, "expert-description") || "";
    const summary = story.summary || subheadline || "";

    const fallbackImage = useSelector((state) =>
        get(state, ["qt", "config", "publisher-attributes", "fallback-image"], "")
    );

    const readMoreLink = storyUrl ? (
        <Link href={storyUrl} styleName="read-more">
            Read article
        </Link>
    ) : null;

    return (
        <div styleName="card-wrapper">
            <div styleName="content-left">
                {formattedDate && <span styleName="date">{formattedDate}</span>}
                <h2 styleName="headline">{headline}</h2>
                {!isMobile && readMoreLink}
            </div>

            <div styleName="content-right">
                <div styleName="image-center">
                    {heroImageKey ? (
                        <ResponsiveImage
                            slug={heroImageKey}
                            metadata={heroImageMetadata}
                            aspectRatio={[1, 1]}
                            defaultWidth={160}
                            widths={[64, 110, 160, 320]}
                            sizes="(max-width: 767px) 110px, (max-width: 1023px) 160px, (max-width: 1279px) 64px, 168px"
                            imgParams={{ auto: ["format", "compress"] }}
                            alt={headline || "Story Image"}
                        />
                    ) : (
                        fallbackImage && <img src={fallbackImage} alt={headline || "Fallback Image"} />
                    )}
                </div>

                <div styleName="expert-info">
                    <p styleName="expert-text">
                        {expertName && (
                            <span styleName="expert-name">
                                <strong>{expertName}</strong>
                            </span>
                        )}
                        {expertDescription && <span styleName="expert-description">, {expertDescription}</span>}
                        {summary && <span styleName="summary"> {summary}</span>}
                    </p>
                    {isMobile && readMoreLink}
                </div>
            </div>
        </div>
    );
};

LeadershipStoryCard.propTypes = {
    story: PropTypes.object,
};
